import React from 'react';
import classNames from 'classnames';

import { formatDateString } from '~libs/dayjs';

import { useGetClientHcpUnspentFundsQuery } from '~support-at-home/actions/clientHcpUnspentFunds';

interface ComponentProps {
  allocated: number;
  available: number;
  client_id?: number;
}

const currencyFormatter = new Intl.NumberFormat('en-AU', {
  style: 'currency',
  currency: 'AUD',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

const BudgetTotalIndicator: React.FC<ComponentProps> = React.memo(({ allocated, available, client_id }) => {
  const isOver = allocated > available;
  const className = classNames('budget-total-indicator', {
    'over-budget': isOver,
  });
  const { data, isLoading, isError } = useGetClientHcpUnspentFundsQuery(
    { client_id },
    { skip: !client_id, refetchOnMountOrArgChange: true },
  );

  const hasHcpBudgets = !isLoading && !isError && Array.isArray(data) && data.length > 0;

  return (
    <div className={className}>
      {hasHcpBudgets && (
        <div className="hcp-unspent-funds">
          <div className="title-label">HCP Unspent Funds</div>
          <div className="rows">
            {data.map((budget, index) => (
              <div key={`${budget.funding_type_name}-${index}`} className="row">
                <div className="row-name">{budget.funding_type_name ?? 'Unknown fund'}</div>
                <div className="details">
                  <div className="label">Total:</div>
                  <span className="currency-value">{currencyFormatter.format(budget.total_amount ?? 0)}</span>
                  <div className="label">Available:</div>
                  <span className="currency-value">{currencyFormatter.format(budget.available_amount ?? 0)}</span>
                  <div className="label">Used:</div>
                  <span className="currency-value">{currencyFormatter.format(budget.used_amount ?? 0)}</span>
                  <span className="row-updated">Updated: {formatDateString(budget.updated_at)}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
      <div>
        <div className="totals">
          <div className="label">Allocated Budget:</div>
          <span className="currency-value">{currencyFormatter.format(allocated)}</span>
          <div className="label">Available Budget:</div>
          <span className="currency-value">{currencyFormatter.format(available)}</span>
        </div>
        <div className="gst-info-caption text-end">All prices budgeted are considered GST Exclusive</div>
      </div>
    </div>
  );
});

BudgetTotalIndicator.displayName = 'BudgetTotalIndicator';
export default BudgetTotalIndicator;
